// extracted by mini-css-extract-plugin
export default {"tableRow":"society_tableRow__93LJ8","tableCell":"society_tableCell__kfOho"};